import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { AutenticacionService } from './autenticacion.service';

@Injectable()
export class RolGuard implements CanActivate {
  constructor(
    private authService: AutenticacionService
  ) { }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (
      this.authService.isAdmin() ||
      this.authService.isUser() ||
      this.authService.isExecutive() ||
      
      this.authService.isEjecutivoReportero() ||
      this.authService.isCobranza() 
    ) {
      return true;
    } else {
      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/services/rol.guard.ts